export type TTokenTypeId = number;

export interface TokenType {
  id: TTokenTypeId;
  name: string;
}
